// Property Type Options
export const PROPERTY_TYPES = [
  { value: 'apartment', label: 'Apartment' },
  { value: 'house', label: 'House' },
  { value: 'villa', label: 'Villa' },
  { value: 'penthouse', label: 'Penthouse' },
];

// Price Type Options
export const PRICE_TYPES = [
  { value: 'per_month', label: 'Per Month' },
  { value: 'per_night', label: 'Per Night' },
];

// Rental Type Options
export const RENTAL_TYPE_OPTIONS = [
  { value: 'shortTerm', label: 'Short Term' },
  { value: 'longTerm', label: 'Long Term' },
];

// Property Age Options
export const PROPERTY_AGE = [
  { value: '<3', label: 'Less than 3 years' },
  { value: '3-5', label: '3-5 years' },
  { value: '6-9', label: '6-9 years' },
  { value: '10-15', label: '10-15 years' },
  { value: '15-20', label: '15-20 years' },
  { value: '>20', label: 'More than 20 years' },
];

// BHK Options
export const BHK_OPTIONS = [
  { value: 1, label: '1 BHK' },
  { value: 2, label: '2 BHK' },
  { value: 3, label: '3 BHK' },
  { value: 4, label: '4 BHK' },
  { value: 5, label: '5 BHK' },
  { value: 6, label: '6+ BHK' },
];

// Furnishing Options
export const FURNISHING_OPTIONS = [
  { value: 'unfurnished', label: 'Unfurnished' },
  { value: 'semi_furnished', label: 'Semi Furnished' },
  { value: 'furnished', label: 'Fully Furnished' },
];

// Parking Options
export const PARKING_OPTIONS = [
  { value: 'not_available', label: 'Not Available' },
  { value: 'open', label: 'Open Parking' },
  { value: 'covered', label: 'Covered Parking' },
  { value: 'allotted', label: 'Allotted Parking' },
];

// Facing Options
export const FACING_OPTIONS = [
  { value: 'north', label: 'North' },
  { value: 'south', label: 'South' },
  { value: 'east', label: 'East' },
  { value: 'west', label: 'West' },
  { value: 'north_east', label: 'North-East' },
  { value: 'north_west', label: 'North-West' },
  { value: 'south_east', label: 'South-East' },
  { value: 'south_west', label: 'South-West' },
];

// Area Unit Options
export const AREA_UNIT_OPTIONS = [
  { value: 'sqr_ft', label: 'Sq. Ft.' },
  { value: 'sqr_mtr', label: 'Sq. Mtr.' },
  { value: 'sqr_yard', label: 'Sq. Yard' },
];

// Status Options
export const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'sold', label: 'Sold' },
  { value: 'rented', label: 'Rented' },
];

// Amenities Options
export const AMENITIES = [
  { value: 'cctv', label: 'CCTV', category: 'Security' },
  { value: 'fire_safety', label: 'Fire Safety', category: 'Security' },
  { value: 'security', label: '24/7 Security', category: 'Security' },
  { value: 'pet_allowed', label: 'Pet Allowed', category: 'Policy' },
  { value: 'bachelor_allowed', label: 'Bachelor Allowed', category: 'Policy' },
  { value: 'gym', label: 'Gym', category: 'Amenities' },
  { value: 'club_house', label: 'Club House', category: 'Amenities' },
  { value: 'play_area', label: 'Play Area', category: 'Amenities' },
  { value: 'garden', label: 'Garden', category: 'Amenities' },
  { value: 'swimming_pool', label: 'Swimming Pool', category: 'Amenities' },
  { value: 'power_backup', label: 'Power Backup', category: 'Utilities' },
  { value: 'elevator', label: 'Elevator', category: 'Utilities' },
  { value: 'parking', label: 'Parking', category: 'Utilities' },
  { value: 'balcony', label: 'Balcony', category: 'Features' },
  { value: 'terrace', label: 'Terrace', category: 'Features' },
  { value: 'modular_kitchen', label: 'Modular Kitchen', category: 'Features' },
  { value: 'wardrobe', label: 'Wardrobe', category: 'Features' },
  { value: 'ac', label: 'Air Conditioning', category: 'Appliances' },
  { value: 'geyser', label: 'Geyser', category: 'Appliances' },
  { value: 'internet', label: 'Internet', category: 'Connectivity' },
  { value: 'cable_tv', label: 'Cable TV', category: 'Connectivity' },
  { value: 'intercom', label: 'Intercom', category: 'Connectivity' },
  { value: 'visitor_parking', label: 'Visitor Parking', category: 'Services' },
  { value: 'maintenance_staff', label: 'Maintenance Staff', category: 'Services' },
  { value: 'housekeeping', label: 'Housekeeping', category: 'Services' },
  { value: 'laundry', label: 'Laundry', category: 'Services' },
  { value: 'medical', label: 'Medical', category: 'Amenities' },
];

// Sort options for property listing
export const SORT_OPTIONS = [
  { value: 'recent', label: 'Most Recent' },
  { value: 'price', label: 'Price: Low to High' },
  { value: 'relevance', label: 'Relevance' },
];

// Helper function to get label from value
export const getLabel = (options, value) => {
  const option = options.find(opt => opt.value === value);
  return option ? option.label : value;
};

// Helper function to format price
export const formatPrice = (price) => {
  return `₹${price?.toLocaleString('en-IN') || 0}`;
};

// Helper function to format area
export const formatArea = (area, unit) => {
  const unitLabel = getLabel(AREA_UNIT_OPTIONS, unit);
  return `${area} ${unitLabel}`;
};

